<div class="machine-container">
  @if (pictogram) {
    <img [width]="48" [height]="48" [ngSrc]="pictogram" [alt]="rowData.displayName" class="machine-image"/>
  }
  <span class="ellipsis" geauiTooltipOnEllipsisV2 [pTooltip]="rowData.displayName">
    {{ rowData.displayName }}
  </span>
</div>
